import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  customTextField: {
    appearance: 'textfield',
    '&::-webkit-inner-spin-button': {
      appearance: 'none',
      margin: 0
    },
    width: '100%',
    '& input': {
      height: 5,
      fontWeight: 500,
      fontSize: '.875rem',
      '&::placeholder': {
        fontSize: '.825rem',
        color: theme.palette.secondary.contrastText
      }
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main
    }
  },
  label: {
    color: theme.palette.primary.main,
    fontSize: '.75rem',
    fontWeight: 600
  }
}))
